import React, { useState, useRef, useEffect } from 'react';
import DateInput from '../../../../../Components/DateInput';
import Dropdown from '../../../../../Components/Dropdown';
import editImg from '../../../../../Assets/Icons/edit.png';
import deleteImg from '../../../../../Assets/Icons/delete.png';
import downArrow from '../../../../../Assets/Icons/chevron-down.png';
import filter from '../../../../../Assets/Icons/filter.png';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../Components/Loader';
import DeleteConfirmationModal from '../../../../../Components/Modals/DeleteConformationModal';
import AddToDoModal from '../../../../../Components/Modals/AddToDoModal';
import TextInput from '../../../../../Components/TextInput';
import ToDoListActiveController from '../../../../Controllers/AdminScreens/AddOns/ToDoList/ToDoListActiveItemsController';
import search from '../../../../../Assets/Icons/search.png';
import { convertGMTToLocal } from '../../../../../Utils/Validation';

const ToDoListActiveItems = ({  activeToDoList, activeToDoError, activeToDoLoading, onRefresh,setActiveToDoLoading,setActiveToDoError ,setActiveToDoList}) => {
    // console.log("selectedDocument", selectedDocument)
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const showFilter = () => {
        setShowFilters(!showFilters);
    }

    const{
        handlePageChange,
        currentToDoActiveItems,
        currentPage,
        totalPages,

        loading,
        success,
        handleCloseDeleteModal,
        handleOpenDeleteModal,
        handleDelete,
        isDeleteModalOpen,
        selectedDocument,
        setSelectedDocument,
        // noticeBoardMsgDeleteError,
        // handleNoticeBoardMessageDelete,
        // currentNoticeDeleteIndex,
        deletedMessages,
        resetFilter,
        noticeBoardActiveFilterListLoading,
        clientSearchError,
        employeeList,
        error,
        employeesListLoading,
        handleSelectedEmployee,
        handleSearchInputChange,
        searchUser,
        handleSearchEmployee,


        currentActiveToDoDeleteIndex,
        activeToDoDeleteError,
        handleToDoActiveItemDelete,

        setDueDate,
        dueDate,
        addedDate,
        setAddedDate,
        toDoFilterError,
        fetchActiveToDoItemsFilterList,
        fileListLoading,
        fileSearchError,
        FileIdList,
        fileError,
        searchFile,
        handleSearchFile,
        selectedFile,
        handleSelectedFile,
        handleFileSearchInputChange
    } = ToDoListActiveController(onRefresh,activeToDoList,setActiveToDoLoading,setActiveToDoError,setActiveToDoList,showFilter);

    const [userPermissions, setUserPermissions] = useState(null);
    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        setUserPermissions(storedUserInfo?.user_permissions || {});
    },[])

    const createAddNewMessage = () => {
        // setSelectedNoticeMessage(null)
        setModalVisible(true)
    }

    const handleCloseModal = () => {
        setModalVisible(false);
        setDocumentData(null);
    };

    const toggleFilters = () => {
        onRefresh();
        setShowFilters(!showFilters);
        resetFilter()
    };

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const formatDate = (dateString) => {
        if (!dateString || dateString === "--" || typeof dateString !== "string" || dateString.trim() === "") {
            return "--";
        }
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    };

    const [documentData, setDocumentData] = useState(null);
    const handleEditDocument = (noticeMsg) => {
        setDocumentData(noticeMsg);
        setModalVisible(true);
    };

    const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();

    return (
        <>
            <div className="tasksScreen-tasks-header">
                <h2 style={{ color: '#1F384C', fontSize: '18px', fontWeight: '500', lineHeight: '19.08px', wordWrap: 'break-word' }}>Active To Do List Items</h2>
                {userPermissions?.add_ons?.per_name_sub_json?.to_do_list === 1 && 
                <button className="tasksScreen-apply-button" style={{ marginBottom: '10px' }} onClick={createAddNewMessage}>Add New To Do Item</button>
                }
            </div>

            <div className="tasksScreen-filters-row" style={{ position: 'relative' }}>
                <div className="tasksScreen-filters-button-wrapper">
                    <button
                        className="tasksScreen-filters-button"
                        onClick={showFilter}
                        style={{padding:'8px 12px'}}
                    >
                        <img src={filter} alt="Filter" style={{width:12}}/>
                        {showFilters ? 'Filters' : 'Filters'}
                    </button>
                </div>
                {showFilters && (
                    <div className="tasksScreen-filters-container-overlay">
                        <div className='tasksScreen-filters'>
                            {/* Created By Dropdown */}
                            <div className="filter-field">
                                    <label style={{ fontSize: '12px', color: '#343C44' }}>Client Name</label>
                                    <TextInput
                                        type="text"
                                        placeholder="Client Name"
                                        value={searchUser}
                                        onChange={(e) => handleSearchInputChange(e.target.value)}
                                        onRightClick={handleSearchEmployee}
                                        // searchBoxWidth={280}
                                        right={
                                            employeesListLoading ? (
                                                <Loader loading={employeesListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                            ) : (
                                                <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                            )
                                        }
                                        style={{ padding: '20px 10px' }}
                                        errorMessage={error || clientSearchError}
                                    />
                                    {employeeList?.length > 0 && (
                                        <ul style={styles.dropdownList}>
                                            {employeeList?.map((employee, index) => (
                                                <li
                                                    key={employee?.client_id}
                                                    onClick={() => handleSelectedEmployee(employee)}
                                                    style={{
                                                        ...styles.dropdownItem,
                                                        borderBottom: index !== employeeList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                                    }}
                                                >
                                                    {employee?.client_name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="filter-field">
                                    <label style={{ fontSize: '12px', color: '#343C44' }}>File No.</label>
                                    <TextInput
                                        type="text"
                                        placeholder="File No."
                                        value={searchFile}
                                        onChange={(e) => handleFileSearchInputChange(e.target.value)}
                                        onRightClick={handleSearchFile}
                                        // searchBoxWidth={280}
                                        right={
                                            fileListLoading ? (
                                                <Loader loading={fileListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                            ) : (
                                                <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                                            )
                                        }
                                        style={{ padding: '20px 10px' }}
                                        errorMessage={fileError || fileSearchError}
                                    />
                                    {FileIdList?.length > 0 && (
                                        <ul style={styles.dropdownList}>
                                            {FileIdList?.map((employee, index) => (
                                                <li
                                                    key={employee?.client_id}
                                                    onClick={() => handleSelectedFile(employee)}
                                                    style={{
                                                        ...styles.dropdownItem,
                                                        borderBottom: index !== FileIdList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                                    }}
                                                >
                                                    {employee?.client_file_id}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>


                            {/* Date Published Date Picker */}
                            <div className="filter-field">
                                <label style={{ fontSize: '12px', color: '#343C44' }}>Date Added</label>
                                <DateInput
                                    value={addedDate}
                                    onChange={(e) => setAddedDate( e.target.value)}
                                    // width={230}
                                />
                            </div>

                            {/* Expiry Date Date Picker */}
                            <div className="filter-field">
                                <label style={{ fontSize: '12px', color: '#343C44' }}>Due Date</label>
                                <DateInput
                                    value={dueDate}
                                    onChange={(e) => setDueDate(e.target.value)}
                                    // width={230}
                                />
                            </div>
                        </div>
                        {/* Filter Buttons */}
                        <div className="tasksScreen-filter-buttons">
                            <button
                                onClick={fetchActiveToDoItemsFilterList}
                                className="tasksScreen-apply-button"
                                style={{
                                    cursor: activeToDoLoading ? "not-allowed" : "pointer",
                                    opacity: activeToDoLoading ? 0.6 : 1,
                                    pointerEvents:activeToDoLoading? 'none' :'auto',
                                    gap: '5px',
                                    display:'flex'
                                }}
                                disabled={activeToDoLoading}
                            >
                                {activeToDoLoading && (
                                    <Loader loading={activeToDoLoading} color={'var(--background-color)'} size="small" />
                                )}
                                <span>Apply</span>
                            </button>
                            <button
                                onClick={toggleFilters}
                                className="tasksScreen-cancel-button"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={resetFilter}
                                className="tasksScreen-reset-button"
                            >
                                Reset
                            </button>
                            {toDoFilterError && <div style={{fontSize:'12px', color:'red', marginTop:'5px'}}>{toDoFilterError} </div>}
                        </div>
                    </div>
                )}
            </div>

            <div className="tasksScreen-task-table-wrapper">
                <table className="tasksScreen-task-table">
                    <thead>

                        {/* Table Headers */}
                        <tr>
                            <th style={{ width: "10%" }}>Date Created</th>
                            <th style={{ width: "30%" }}>Description</th>
                            <th style={{ width: "20%" }}>Client Name</th>
                            <th style={{ width: "20%" }}>File No.</th>
                            <th style={{ width: "10%" }}>Due Date</th>
                            <th style={{ width: "10%" }}></th>
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: '#fff' }}>
                        {currentToDoActiveItems?.map((activeTodo, index) => (
                            <React.Fragment key={index}>
                                <tr className={`tasksScreen-main-task-row ${activeTodo.showDetails ? 'tasksScreen-show-border' : ''}`}>
                                    <td>{convertGMTToLocal(activeTodo?.create_at, "MM-dd-yyyy") || '--'}</td>
                                    <td>{activeTodo?.sc_desc || '--'}</td>
                                    <td>{activeTodo?.client_name || '--'}</td>
                                    <td>{activeTodo?.client_file_id || '--'}</td>
                                    <td>{convertGMTToLocal(activeTodo?.sc_time, "MM-dd-yyyy") || '--'}
                                    {activeToDoDeleteError && currentActiveToDoDeleteIndex=== index &&
                                            <div style={{ color: 'red', textDecoration: 'none' }}>{activeToDoDeleteError}</div>}
                                        {success && currentActiveToDoDeleteIndex=== index &&
                                            <div style={{ color: 'green', textDecoration: 'none' }}>{success}</div>}
                                    </td>
                                    <td>
                                    {userPermissions?.add_ons?.per_name_sub_json?.to_do_list === 1 && 
                                    <div style={{ display: "flex", alignItems: "center", gap: "5px",justifyContent: "end", }}>
                                        <button className="tasksScreen-edit-button" style={{
                                            opacity: (loading && currentActiveToDoDeleteIndex === index) || deletedMessages.includes(activeTodo.sc_id) ? 0.5 : 1,
                                            cursor: (loading && currentActiveToDoDeleteIndex === index) || deletedMessages.includes(activeTodo.sc_id) ? 'not-allowed' : 'pointer',
                                            pointerEvents: (loading && currentActiveToDoDeleteIndex === index) || deletedMessages.includes(activeTodo.sc_id) ? 'none' : 'auto',
                                        }}
                                        >
                                            <img src={editImg} alt="Edit" onClick={() => handleEditDocument(activeTodo)}  style={{ height: '16px', width: '16px'}} />
                                        </button>
                                        <button className="tasksScreen-delete-button" style={{
                                            opacity: (loading && currentActiveToDoDeleteIndex === index) || deletedMessages.includes(activeTodo.sc_id) ? 0.5 : 1,
                                            cursor: (loading && currentActiveToDoDeleteIndex === index) || deletedMessages.includes(activeTodo.sc_id) ? 'not-allowed' : 'pointer',
                                            pointerEvents: (loading && currentActiveToDoDeleteIndex === index) || deletedMessages.includes(activeTodo.sc_id) ? 'none' : 'auto',
                                        }}
                                        >
                                            <img src={deleteImg} alt="Delete" onClick={() => { handleDelete(activeTodo, index) }}  style={{ height: '16px', width: '16px'}} />
                                        </button>
                                        {loading && currentActiveToDoDeleteIndex=== index && (
                                                <span style={{ marginLeft: '5px' }}>
                                                    <Loader loading={loading} color={'var(--primary-loader-color)'} size="small" />
                                                </span>
                                            )}
                                    </div>
                                    }
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
                {activeToDoError && <div className="list-error-msg">{activeToDoError} </div>}
                {/* {noticeBoardActiveMessagesError && <div className="list-error-msg">{noticeBoardActiveMessagesError} </div>} */}
                {activeToDoLoading && <Loader loading={activeToDoLoading} color={'var(--primary-loader-color)'} />}
                {/* {noticeBoardActiveFilterListLoading && <Loader loading={noticeBoardActiveFilterListLoading} color={'var(--primary-loader-color)'} />} */}
            </div>

            <div className="tasksScreen-table-footer">
                <span className="tasksScreen-pagination-info">
                    {`${currentPage}-${totalPages} of items`}
                </span>
                <div className="tasksScreen-pagination">
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
                        <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image " />
                    </button>
                    {/* {[...Array(totalPages)].map((_, index) => (
                        <button key={index} className={`tasksScreen-pagination-button ${currentPage === index + 1 ? 'active' : ''}`} onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    ))} */}
                    {/* Page Numbers */}
                    {visiblePages?.map((page) => (
                        <button
                            key={page}
                            className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </button>
                    ))}
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                        <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                    </button>
                </div>
                <AddToDoModal isOpen={modalVisible} onClose={handleCloseModal} source="todoactiveitems" documentData={documentData} fetchToDoList={onRefresh}/>
                <DeleteConfirmationModal
                    isOpen={isDeleteModalOpen}
                    message={`Are you sure you want to delete ${selectedDocument?.activeTodo?.sc_desc}?`}
                    onClose={handleCloseDeleteModal}
                    onConfirm={() => {
                    handleCloseDeleteModal();
                    handleToDoActiveItemDelete();
                    }}
                />
            </div>
        </>
    );
};

const styles = {
    header: {
        fontSize: "22px",
        color: "#060606",
        marginBottom: "10px",
        fontWeight: 500,
        // fontFamily: 'Montserrat',
        //   marginLeft:'20px'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center', // Vertically align items
    },
    leftHeader: {
        marginTop: '-5px'
    },
    dropdownList: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },

    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};

export default ToDoListActiveItems;
